let watchID;

export default {
    retrieve(callback) {
        if ('geolocation' in navigator) {
            const options = {
                timeout: 5000
            };
            navigator.geolocation.getCurrentPosition((position) => {
                callback(position.coords);
            }, (error) => {
                if (error.code === 1) {
                    callback('blocked');
                    return;
                }
                callback('timeout');
            }, options);

            watchID = navigator.geolocation.watchPosition((position) => {
                callback(position.coords);
            });
        }
    },
    clearWatch() {
        if ('geolocation' in navigator) {
            navigator.geolocation.clearWatch(watchID);
        }
    }
};
